import React, { useState } from 'react';
import MobileFrame from './components/layout/MobileFrame';
import BottomNavBar from './components/layout/BottomNavBar';
import Dashboard from './components/screens/Dashboard';
import SodaLocator from './components/screens/SodaLocator';
import AICoaching from './components/screens/AICoaching';
import Wallet from './components/screens/Wallet';
import Profile from './components/screens/Profile';
import Onboarding from './components/screens/Onboarding';
import BaristaLogin from './components/screens/BaristaLogin';
import BaristaAdmin from './components/screens/BaristaAdmin';
import { HydrationProvider } from './contexts/HydrationContext';
export function App() {
  const [currentScreen, setCurrentScreen] = useState('onboarding');
  const [onboardingComplete, setOnboardingComplete] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminLoggedIn, setAdminLoggedIn] = useState(false);
  const handleCompleteOnboarding = () => {
    setOnboardingComplete(true);
    setCurrentScreen('home');
  };
  const handleAdminLogin = () => {
    setAdminLoggedIn(true);
  };
  const handleAdminLogout = () => {
    setAdminLoggedIn(false);
    setIsAdmin(false);
    setCurrentScreen('home');
  };
  // Handle admin mode toggle
  const toggleAdminMode = () => {
    setIsAdmin(true);
    setCurrentScreen('admin');
  };
  const renderScreen = () => {
    // Admin flow
    if (isAdmin) {
      if (!adminLoggedIn) {
        return <BaristaLogin onLogin={handleAdminLogin} data-id="element-0" />;
      }
      return <BaristaAdmin onLogout={handleAdminLogout} data-id="element-1" />;
    }
    // Regular user flow
    if (!onboardingComplete) {
      return <Onboarding onComplete={handleCompleteOnboarding} data-id="element-2" />;
    }
    switch (currentScreen) {
      case 'home':
        return <Dashboard data-id="element-3" />;
      case 'map':
        return <SodaLocator data-id="element-4" />;
      case 'coach':
        return <AICoaching data-id="element-5" />;
      case 'wallet':
        return <Wallet data-id="element-6" />;
      case 'profile':
        return <Profile onToggleAdminMode={toggleAdminMode} data-id="element-7" />;
      default:
        return <Dashboard data-id="element-8" />;
    }
  };
  return <HydrationProvider data-id="element-9">
      <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4" data-id="element-10">
        <MobileFrame data-id="element-11">
          {renderScreen()}
          {onboardingComplete && !isAdmin && <BottomNavBar activeScreen={currentScreen} onChangeScreen={setCurrentScreen} data-id="element-12" />}
        </MobileFrame>
      </div>
    </HydrationProvider>;
}